exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n[data-v-937cc3bc] .slider{\n    width: 100%;\n}\n", ""]);

